import { SECONDS_TO_MS_RATIO } from 'services/helpers/formatTime';
import { Sentence } from 'shared-types/lyrics';

import { CURSOR_SWIPE_DURATION_IN_S } from './Sentence.style';

const CURSOR_SWIPE_DURATION_IN_MS = CURSOR_SWIPE_DURATION_IN_S * SECONDS_TO_MS_RATIO;

export const getWordAnimationDurationInMs = (wordStart: number, wordEnd: number) =>
  wordEnd - wordStart;

export const getWordAnimationDelayInMs = (
  wordStart: number,
  blockStartOrLastManualTimeUpdate: number,
) => {
  return wordStart - blockStartOrLastManualTimeUpdate;
};

export const getCursorAnimationDelayInMs = (
  firstWordStartInMs: number,
  blockStartOrLastManualTimeUpdate: number,
) => {
  const cursorAnimationStartTime = firstWordStartInMs - CURSOR_SWIPE_DURATION_IN_MS;
  const cursorRenderTimeInMs = blockStartOrLastManualTimeUpdate;

  return cursorAnimationStartTime - cursorRenderTimeInMs;
};

export const getSentenceAnimationsDelayInMs = (
  sentence: Sentence,
  blockStartOrLastManualTimeUpdate: number,
  fade: number,
) => {
  return [
    sentence.sentenceStart - blockStartOrLastManualTimeUpdate - fade,
    sentence.sentenceEnd - blockStartOrLastManualTimeUpdate,
  ];
};
